import ConfigService from 'shared/services/config.service';
import { JsonType } from 'types/json-type';

export const getSourceSystemRegexMapping = (): JsonType =>
  JSON.parse(ConfigService.getConfigValue('Settings', 'SourceSystemRegexMapping') || '{}');
